/**
 * A run error with its ACTION picked out.
 *
 * The trail-attribution failure is the one error an operator is expected to fix
 * themselves, and it offers two routes depending on whether the earlier month
 * was ever paid: run it, or import its rates alone. Buried in a paragraph of red
 * body text that reads as explanation rather than instruction, so the whole
 * action sentence is underlined and bolded and the rest stays prose.
 *
 * Matched VERBATIM against CommissionEngineService.ACTION_HINT. If the wording
 * changes there and not here the message still renders — it just stops being
 * highlighted, which is why this degrades to plain text rather than throwing.
 * That also means a drift is silent, so the constant carries a warning.
 */

const ACTIONS = [
    'Do a commission run for the month each one first appeared or only '
        + 'import rate splits if transactions are settled',
];

const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const PATTERN = new RegExp(`(${ACTIONS.map(escape).join('|')})`, 'g');

export default function RunErrorText({ text }) {
    if (!text) return null;

    // String.split with a capturing group keeps the separators, so the parts
    // alternate prose / action / prose without losing any of the message.
    return (
        <>
            {String(text).split(PATTERN).map((part, i) =>
                ACTIONS.includes(part) ? (
                    <strong
                        key={i}
                        className="font-bold text-red-900 underline decoration-red-400 decoration-2 underline-offset-2"
                    >
                        {part}
                    </strong>
                ) : (
                    <span key={i}>{part}</span>
                ),
            )}
        </>
    );
}
